import { Outlet } from "react-router-dom";

export default function Content(){
  return(
    <Outlet />
  )
}